import React, {Component} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextButton from '@spothero/ui/text-button';

class GettingThere extends Component {
    static propTypes = {
        className: PropTypes.string,
        facility: PropTypes.object.isRequired,
        rate: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
            .isRequired,
        isMonthly: PropTypes.bool.isRequired,
        /** An optional title to set the section to. If none is set, the facility title is used. */
        sectionTitle: PropTypes.string,
    };

    constructor(props) {
        super(props);

        this.state = {
            showFullInstructions: false,
        };
    }

    _onClickReadMore = () => {
        this.setState({
            showFullInstructions: true,
        });
    };

    render() {
        const {className, facility, rate, isMonthly, sectionTitle} = this.props;
        const {showFullInstructions} = this.state;
        const classes = classNames('GettingThere', className, {
            'GettingThere-show-full-instructions': showFullInstructions,
        });
        const title = sectionTitle ? sectionTitle : facility.title;
        const copy =
            isMonthly && rate && rate.getting_here
                ? rate.getting_here.replace(/\\r?\n/g, '<br>')
                : facility.getting_here.replace(/\\r?\n/g, '<br>');

        return (
            <div className={classes}>
                <h3 className="title">{title}</h3>
                <div className="preview-container">
                    <p
                        className="instructions"
                        dangerouslySetInnerHTML={{__html: copy}}
                    />
                    <div className="overlay" />
                </div>
                <TextButton
                    className="read-more"
                    onClick={this._onClickReadMore}
                >
                    Show More
                </TextButton>
            </div>
        );
    }
}

export default GettingThere;
